// Document Status-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * Document Status-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing document status module code
 */
export const createDocumentStatusValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return the same interface but with document status-specific method names
  return {
    schema: validation.schema,
    validateDocumentStatusData: validation.validateData,
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createDocumentStatusValidation;
